import { PagenatedResponse, SearchPagenateQuery } from '@models/common';
import { KakaoNotificationLog } from '@models/notifications';
import { create } from 'zustand';

const PAGE_SIZE = 20;

interface KakaoNotificationLogsContainer {
  contents: KakaoNotificationLog[];
  page: number;
  size: number;
  total: number;
  hasNext: boolean;
}

interface KakaoNotificationLogsStoreProps {
  searchResultContainer: KakaoNotificationLogsContainer;
  searchQuery: SearchPagenateQuery;
  searchKeyword?: string;
  setStartDate: (date: string | null) => void;
  setEndDate: (date: string | null) => void;
  setSearchKeyword: (keyword: string) => void;
  updateSearchQuery: (query: { [key: string]: any }) => void;
  resetSearchQuery: (pageSize?: number) => void;
  setKakaoNotificationLogsContainer: (result: PagenatedResponse<KakaoNotificationLog>) => void;
}

export const useKakaoNotificationLogsStore = create<KakaoNotificationLogsStoreProps>((set) => ({
  searchResultContainer: {
    contents: [] as KakaoNotificationLog[],
    total: 0,
    page: 0,
    size: 0,
    hasNext: false,
  },
  searchQuery: {
    page: 0,
    size: PAGE_SIZE,
    type: 'all',
    startDate: undefined,
    endDate: undefined,
  },
  setStartDate: (date: string | null) => {
    set((state) => {
      return { ...state, searchQuery: { ...state.searchQuery, startDate: date } };
    });
  },
  setEndDate: (date: string | null) => {
    set((state) => {
      return { ...state, searchQuery: { ...state.searchQuery, endDate: date } };
    });
  },
  searchKeyword: undefined,
  setKakaoNotificationLogsContainer: (result) => {
    set((state) => {
      const contents = new Array(result.total || PAGE_SIZE);
      contents.splice(result.page * result.size, result.size, ...(result?.contents || []));
      const newValue = { ...state.searchResultContainer, ...result, contents: contents };
      return { ...state, searchResultContainer: newValue };
    });
  },
  setSearchKeyword: (keyword: string) => {
    set((state) => {
      return {
        ...state,
        searchKeyword: keyword,
        searchResultContainer: { ...state.searchResultContainer, size: 0 },
      };
    });
  },
  updateSearchQuery: (query: { [key: string]: any }) => {
    set((state) => {
      return {
        ...state,
        searchQuery: { ...state.searchQuery, ...query },
        searchResultContainer: { ...state.searchResultContainer, size: 0 },
      };
    });
  },
  resetSearchQuery: (pageSize?: number) => {
    set({
      searchQuery: {
        page: 0,
        size: pageSize || PAGE_SIZE,
        type: 'all',
        startDate: undefined,
        endDate: undefined,
      },
    });
  },
}));
